import { IComponentOptions } from 'angular';
import template from './progress-settings.html';
import controller from './progress-settings.controller';

import './progress-settings.scss';

/**
 * @type {IComponentOptions}
 */
const component = {
	template,
	bindings: {
		widget: '<',
		parent: '=',
	},
	transclude: true,
	controller,
};

export default component;
